<template src="./footer.html" />

<script>
export default {
  name: 'ProFooter',
  props: {
    fluid: { type: Boolean, default: false },
    containerType: { type: String, default: 'container' },
  },
  data() {
    return {
      portal: this.$portal,
      company: this.$company,
      brain: this.$brain,

      defaultTarget: '_blank',
      isMobile: window.innerWidth <= 767,
    };
  },
  computed: {
    visible() {
      if (this.$route.name == '404') return false;
      return true;
    },
    contents() {
      return _.get(this.company, 'json.footer.items', []);
    },
    superfooter() {
      return _.get(this.company, 'json.footer.html', '');
    },
    showDeveloperAfter() {
      return _.get(this.company, 'json.footer.showDeveloperAfter', false);
    },
    hideDeveloper() {
      return _.get(this.company, 'json.footer.hideDeveloper', false);
    },
    lgpd() {
      return _.get(this.company, 'json.lgpd', {});
    },
    companyName() {
      return _.get(this.company, 'json.companyName', '');
    },
    address() {
      return _.get(this.company, 'json.address', {});
    },
    cnpj() {
      return _.get(this.company, 'json.cnpj', '');
    },
  },
  mounted() {
    window.addEventListener('resize', this.getWidthSize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.getWidthSize);
  },
  methods: {
    getWidthSize(e) {
      const { target } = e;

      this.isMobile = target.innerWidth <= 767;
    },
  },
};
</script>

<style scoped src="./footer.scss" lang="scss"></style>
